// extracted by mini-css-extract-plugin
export var expandedRowWrapper = "_22-6";
export var headerCell = "_22-2";
export var loadingStateContent = "_22-8";
export var rowWrapper = "_22-4";
export var stickyAggregationCell = "_22-b";
export var stickyAggregationRow = "_22-7";
export var stickyColumnCell = "_22-a";
export var stickyColumnHeaderCell = "_22-9";
export var table = "_22-1";
export var virtualRowWrapper = "_22-5";
export var virtualTableContainer = "_22-0";
export var white = "_22-3";